var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(el){return _c('NewsItem',{key:el.id,attrs:{"news":el}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }